import { Canvas } from "@react-three/fiber"
import "./styles.scss"
import { Col, Row, Modal } from "antd"

import ArrowIcon from "../../assets/images/arrow.svg"
import ArrowSatellite from "../../assets/images/arrow-satellite.svg"
import { useRef, useState, useEffect } from "react"

import { OrbitControls } from "@react-three/drei"
import Earth from "../../components/earth/Earth"
import { Vector3 } from "three"

import listSatellite from "../../assets/jsons/satellite.json"
import Satellite from "../../components/satellite/Satellite"
import CameraControls from "../../components/cameraControls/CameraControls"

import abs3aImage from "../../assets/images/abs3a-1.png"
import satelliteImageId1 from "../../assets/images/hotbird-13.png"
import satelliteImageId2 from "../../assets/images/eutelsat-7wa.png"
import satelliteImageId3 from "../../assets/images/eutelsat-7wb.png"
import satelliteImageId4 from "../../assets/images/eutelsat-7bc.png"
import satelliteImageId5 from "../../assets/images/intelsat-20.png"
import satelliteImageId7 from "../../assets/images/se5.png"
import satelliteImageId8 from "../../assets/images/abs3a-1.png"
import satelliteImageId14 from "../../assets/images/asiasat-5.png"
import satelliteImageId15 from "../../assets/images/asiasat-7.png"
import satelliteImageId17 from "../../assets/images/se5.png"
import satelliteImageId18 from "../../assets/images/optusdn.png"

const Main = () => {
  const satelliteImageMap = {
    1: satelliteImageId1,
    2: satelliteImageId2,
    3: satelliteImageId3,
    4: satelliteImageId4,
    5: satelliteImageId5,
    7: satelliteImageId7,
    8: satelliteImageId8,
    14: satelliteImageId14,
    15: satelliteImageId15,
    17: satelliteImageId17,
    18: satelliteImageId18,
  }

  const [showSelect, setShowSelect] = useState(
    window.matchMedia("(max-width: 768px)").matches
  )

  // Effect to add event listener to window resize
  useEffect(() => {
    const handleResize = () => {
      setShowSelect(window.matchMedia("(max-width: 768px)").matches)
    }

    window.addEventListener("resize", handleResize)

    // Cleanup function to remove event listener
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const [selectedSatellite, setSelectedSatellite] = useState(null)
  const cameraControlRef = useRef()
  const earthRef = useRef()
  const [allSatelites, setAllSatelites] = useState([])
  const [isShowModalCoverage, setIsShowModalCoverage] = useState(false)
  const [isEarthRotating, setIsEarthRotating] = useState(false)
  const [satelliteList, setSatelliteList] = useState(listSatellite)
  const [selectedContinent, setSelectedContinent] = useState("All Satellites")
  const onSelectSatellite = (el) => {
    if (!selectedSatellite || selectedSatellite?.id !== el.id) {
      setSelectedSatellite(el)
      setAllSatelites([...allSatelites, el])
    } else {
      setAllSatelites([])
      setSelectedSatellite()
    }
  }

  const handleRotateToLocation = (value) => {
    setIsEarthRotating(true)
    let lon = 0
    let lat = 0
    let isRotating = true
    if (value === "All Satellites") {
      lon = 90
      lat = 40
      isRotating = false
    }
    if (value === "Europe, Middle East & Africa") {
      lon = 60
      lat = 50
    }

    if (value === "Americas") {
      lon = 80
      lat = 170
    }

    if (value === "Asia Pacific") {
      lon = 80
      lat = -20
    }

    earthRef.current.rotateToLocation(lon, lat, isRotating)
    setTimeout(() => {
      setIsEarthRotating(false)
    }, 2000)
  }

  const onShowModalCoverage = () => {
    cameraControlRef.current.zoomToEarch().then(() => {
      setIsShowModalCoverage(true)
    })
  }

  const onCancelShowCoverage = () => {
    cameraControlRef.current.focusOnObject()
    setIsShowModalCoverage(false)
  }

  const onToggleSatelliteMap = () => {
    if (!isShowModalCoverage) {
      onShowModalCoverage()
    } else {
      onCancelShowCoverage()
    }
  }

  const filterSatteliteByContinent = (value) => {
    const valueText = showSelect ? value.target.value : value.target.innerText
    if (isEarthRotating) {
      return
    }
    setAllSatelites([])
    setSelectedSatellite()
    handleRotateToLocation(valueText)
    let continents = []
    setSelectedContinent(valueText)
    if (valueText === "All Satellites") {
      setSatelliteList(listSatellite)
      return
    }
    if (valueText === "Europe, Middle East & Africa") {
      continents = [
        "Europe, Middle East & Africa",
        "Europe",
        "Middle East",
        "Africa",
        "North Africa",
        "Sub-Saharan Africa",
      ]
    }

    if (valueText === "Americas") {
      continents = [
        "America",
        "Americas",
        "Latin America",
        "North America",
        "Brazil",
      ]
    }

    if (valueText === "Asia Pacific") {
      continents = ["Central Asia", "Asia", "South-East Asia", "China", "India"]
    }

    let filteredSatellites = []
    for (let i = 0; i < listSatellite.length; i++) {
      let satellite = listSatellite[i].coverage
      for (let j = 0; j < satellite.length; j++) {
        if (continents.includes(satellite[j])) {
          filteredSatellites.push(listSatellite[i])
          break
        }
      }
    }
    setSatelliteList(filteredSatellites)
    return
  }

  return (
    <>
      <Row className="main-page-container">
        {!isShowModalCoverage && (
          <>
            <Col span={24} className="mt-[53px]">
              {showSelect && (
                <div className="select-area-mobile-wrapper">
                  <label className="select-area-mobile-label">
                    SELECT REGION
                  </label>
                  <select
                    className="select-area-mobile"
                    onChange={filterSatteliteByContinent}
                  >
                    <option value="Europe, Middle East & Africa">
                      Europe, Middle East & Africa
                    </option>
                    <option value="Americas">Americas</option>
                    <option value="Asia Pacific">Asia Pacific</option>
                    <option selected value="All Satellites">
                      All Satellites
                    </option>
                  </select>
                </div>
              )}
              {!showSelect && (
                <div className="select-area">
                  <div
                    onClick={filterSatteliteByContinent}
                    className={`area ${
                      selectedContinent == "Europe, Middle East & Africa"
                        ? "selected"
                        : ""
                    }`}
                  >
                    Europe, Middle East & Africa
                  </div>
                  <div
                    onClick={filterSatteliteByContinent}
                    className={`area ${
                      selectedContinent == "Americas" ? "selected" : ""
                    }`}
                  >
                    Americas
                  </div>
                  <div
                    onClick={filterSatteliteByContinent}
                    className={`area ${
                      selectedContinent == "Asia Pacific" ? "selected" : ""
                    }`}
                  >
                    Asia Pacific
                  </div>
                  <div
                    onClick={filterSatteliteByContinent}
                    className={`area ${
                      selectedContinent == "All Satellites" ? "selected" : ""
                    }`}
                  >
                    All Satellites
                  </div>
                </div>
              )}
            </Col>
            <Col
              span={24}
              className={`mt-[48px] ${
                !showSelect ? "min-h-[310px]" : "min-h-[100px]"
              }`}
            >
              {showSelect && (
                <div className="select-area-mobile-wrapper">
                  <label className="select-area-mobile-label">
                    SELECT SATELLITE
                  </label>
                  <select
                    className="select-area-mobile"
                    onChange={(value) => {
                      onSelectSatellite(
                        satelliteList.find((el) => el.id == value.target.value)
                      )
                    }}
                  >
                    {satelliteList.map((el) => {
                      return (
                        <option key={el.id} value={el.id}>
                          {el.name}
                        </option>
                      )
                    }, [])}
                  </select>
                </div>
              )}

              {!showSelect && (
                <Row className="select-satellite " gutter={[10, 8]}>
                  {satelliteList.map((el) => {
                    return (
                      <Col
                        key={el.id}
                        lg={6}
                        md={8}
                        sm={12}
                        xs={24}
                        onClick={() => {
                          onSelectSatellite(el)
                        }}
                      >
                        <div
                          className={`satellite ${
                            el.id === selectedSatellite?.id ? "selected" : ""
                          }`}
                        >
                          <div className="name">{el.name}</div>
                          <img src={ArrowSatellite} alt="" />
                        </div>
                      </Col>
                    )
                  })}
                </Row>
              )}
            </Col>
          </>
        )}
      </Row>
      {showSelect && (
        <div
          className={`satellite-info-modal-mobile ${
            selectedSatellite ? "show" : ""
          }`}
        >
          <div
            className="satellite-info"
            style={{
              width: "100%",
            }}
          >
            <div className="name">{selectedSatellite?.name}</div>
            <div className="info mt-[15px]">
              <span className="title">Position:</span>
              <span className="value"> {selectedSatellite?.position}</span>
            </div>
            <div className="info mt-[15px]">
              <span className="title">Coverage:</span>
              <span className="value">
                {" "}
                {selectedSatellite?.coverage.join(", ") ?? ""}
              </span>
            </div>
            {selectedSatellite?.description && (
              <div className="description mt-[18px]">
                {selectedSatellite?.description}
              </div>
            )}
            <div className="mt-[28px]">
              <button
                className="btn-view-map"
                onClick={() => {
                  onToggleSatelliteMap()
                }}
              >
                {!isShowModalCoverage
                  ? "View Coverage Map"
                  : "Back to Satellite list"}
              </button>
            </div>
          </div>
        </div>
      )}
      <Row className="relative">
        {!showSelect && (
          <div
            className={`satellite-info-modal ${
              selectedSatellite ? "show" : ""
            }`}
          >
            <div className="satellite-info">
              <div className="name">{selectedSatellite?.name}</div>
              <div className="info mt-[15px]">
                <span className="title">Position:</span>
                <span className="value"> {selectedSatellite?.position}</span>
              </div>
              <div className="info mt-[15px]">
                <span className="title">Coverage:</span>
                <span className="value">
                  {" "}
                  {selectedSatellite?.coverage.join(", ") ?? ""}
                </span>
              </div>
              {selectedSatellite?.description && (
                <div className="description mt-[18px]">
                  {selectedSatellite?.description}
                </div>
              )}
              <div className="mt-[28px]">
                <button
                  className="btn-view-map"
                  onClick={() => {
                    onToggleSatelliteMap()
                  }}
                >
                  {!isShowModalCoverage
                    ? "View Coverage Map"
                    : "Back to Satellite list"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isShowModalCoverage && (
          <div className="coverage-image-container">
            <img src={satelliteImageMap[selectedSatellite.id]} alt="" />
          </div>
        )}
        <Canvas
          style={{
            width: "100%",
            height: showSelect ? "500px" : "845px",
          }}
          orthographic={false}
          camera={{
            fov: 45,
          }}
        >
          <color attach={"background"} args={["#0F0F0F"]} />
          <ambientLight intensity={0.8} color={"#FFFFFF"} />
          <Earth ref={earthRef} showSelect={showSelect} />
          <Satellite
            cameraControlRef={cameraControlRef}
            selectedSatellite={selectedSatellite}
            allSatelites={allSatelites}
            showSelect={showSelect}
          />
          <CameraControls showSelect={showSelect} ref={cameraControlRef} />
        </Canvas>
      </Row>
    </>
  )
}
export default Main
